export const LAYOUT_CONTENT_HEIGHT = { base: '94vh', md: '100vh' }
